/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { UserRead } from './UserRead';
import {
    UserReadFromJSON,
    UserReadFromJSONTyped,
    UserReadToJSON,
    UserReadToJSONTyped,
} from './UserRead';

/**
 * Paginated response for the superadmin user list.
 * @export
 * @interface PaginatedUsersResponse
 */
export interface PaginatedUsersResponse {
    /**
     * Users on this page
     * @type {Array<UserRead>}
     * @memberof PaginatedUsersResponse
     */
    items: Array<UserRead>;
    /**
     * Total number of matching users
     * @type {number}
     * @memberof PaginatedUsersResponse
     */
    total: number;
    /**
     * Number of records skipped
     * @type {number}
     * @memberof PaginatedUsersResponse
     */
    skip: number;
    /**
     * Maximum number of records returned
     * @type {number}
     * @memberof PaginatedUsersResponse
     */
    limit: number;
}

/**
 * Check if a given object implements the PaginatedUsersResponse interface.
 */
export function instanceOfPaginatedUsersResponse(value: object): value is PaginatedUsersResponse {
    if (!('items' in value) || value['items'] === undefined) return false;
    if (!('total' in value) || value['total'] === undefined) return false;
    if (!('skip' in value) || value['skip'] === undefined) return false;
    if (!('limit' in value) || value['limit'] === undefined) return false;
    return true;
}

export function PaginatedUsersResponseFromJSON(json: any): PaginatedUsersResponse {
    return PaginatedUsersResponseFromJSONTyped(json, false);
}

export function PaginatedUsersResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): PaginatedUsersResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'items': ((json['items'] as Array<any>).map(UserReadFromJSON)),
        'total': json['total'],
        'skip': json['skip'],
        'limit': json['limit'],
    };
}

export function PaginatedUsersResponseToJSON(json: any): PaginatedUsersResponse {
    return PaginatedUsersResponseToJSONTyped(json, false);
}

export function PaginatedUsersResponseToJSONTyped(value?: PaginatedUsersResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'items': ((value['items'] as Array<any>).map(UserReadToJSON)),
        'total': value['total'],
        'skip': value['skip'],
        'limit': value['limit'],
    };
}

